<template>
  <div id="dashboard-moneyball-stick" :class="getClass(dashboardLayoutCard.dashboardCardTypeCode, dashboardLayoutCard.sequenceNumber)">
    <div class="dashboard-header">
      <div class="dashboard-title">
        <div class="dashboard-title-details">
          <a href="/analytics/profiles" @click="$parent.logViewDetailsEvent(title)">            
            Moneyball <br>
            Stick
          </a>
          <smart-center-link v-if="displayDashboard" page="Competitive Dashboard" location="Moneyball Stick" />
          <span class="ml-2"><modal-link :modal-id="title" :content-list="pageContentForDashboard"></modal-link></span>
        </div>
        <div class="dashboard-save-dashboard-card"  @click="$modal.show(modalName)"> 
            Save for Report
            <span class="m-1">
              <font-awesome-icon :icon="['fa', 'floppy-disk']" />
            </span>
        </div>
      </div>
      <div class="dashboard-widgets dashboard-moneyball-stick pl-0 pr-0">
        <dashboard-card-dropdown label="Stick Type" :default-dropdown-option="'Select'" :read-only="readOnly" :options="stick_type_options" :default-value="stickType" @change="saveStickType"></dashboard-card-dropdown>
        <div class="dashboard-card-dropdown">        
          <div class="control-label">{{ byTypeName }}</div>
          <multiselect
            ref="stickByOptionSelect"
            :disabled="readOnly"
            v-model="values"
            :options="byTypeOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :max-height="250"
            select-label=""
            deselect-label=""
            selected-label=""
            placeholder="Select Checkboxes"
            label="name"
            :max="maximumStickByOptions"
            name="multi-stick-by-option"
            track-by="value"
            :preselect-first="false"
            @close="updateCard"
            @select="addStickByOption"
            @remove="removeStickByOption"
          >
            <template slot="maxElements">
              <span style="color: #e54d42">{{ maximumStickByOptionMessage }}</span><a href="#" @click="clearSelections">Click here to clear selections</a>
            </template>
            <template #selection="{ values, isOpen }">
              <span class="multiselect__single"
                    v-if="values.length >= 1"
                    v-show="!isOpen">{{ values.length }} selected <a style="float:right" v-if="values.length >= 3" href="#" @click="clearSelections">Clear</a></span>
            </template>            
            <template #option="props">
              <span class="checkbox-label"  @click.self="select(props.option)">
                <input name="multi-stick-by-option" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                {{ props.option.name }}
              </span>
            </template>
          </multiselect>
        </div>
      </div>
      <dashboard-card-expand :dashboard-id="dashboardId" />
    </div>
    <div class="dashboard-divider"></div>
    <div :id="containerId" class="dashboard-card-body">
      <dashboard-card-skeleton v-if="!displayDashboard" />
      <moneyball-stick-chart ref="eChart"
            v-show="this.noData == false && this.displayDashboard == true" 
            :e-chart-mini-id="'moneyball-stick-mini'"
            :e-chart-id="'moneyball-stick'"
            :input-report-type-name="reportTypeName"
            :input-client-chart="this.entryClientChart"
            :modal-id="'profile-by-moneyball-stick-chart'"/>        
      <div v-if="this.noData == true && this.displayDashboard == true" class="no-data-for-chart-container" style="height: 250px;">
          <div v-show="this.noData == true" class="no-data-for-chart mx-auto">
            <div class="pb-2">Not enough data in your selection</div>
            <div class="pb-2">exists to build a digital profile.</div>
            <div class="pb-2">Try selecting a different period,</div>
            <div class="pb-2">organization or stick type.</div>
          </div>
      </div>
    </div>
    <dashboard-modal 
      :modal-id="dashboardId" 
      :chart="this.chart" 
      :client-chart="this.clientChart" 
      :modal-chart-options="options"
      :dashboard-card-report-page-type-name="reportTypeName" 
      :show-moneyball-stick-display="displayDashboard"
      :modal-title="title" 
       />    
    <vue-modal :ref="modalName" :name="modalName" :width="350" :height="200">
      <save-chart :modal-name="modalName" button-label="Save for Report" :chart-title="this.chartTitle" :initial-client-chart="this.clientChart" @save="this.updateClientCharts" @closeModal="closeModal(this.modalName)"></save-chart>
    </vue-modal>
  </div>
</template>

<script>
import DashboardMixins from "../../mixins/DashboardMixins.vue";
import DashboardService from "../../services/dashboard.service";
import AdminService from "../../services/admin.service";
import ClientCompetitorService from "../../services/client.competitor.service";
import ClientTimePeriodService from "../../services/client.time.period.service";
import ChartService from "../../services/chart.service";
import SurveyService from "../../services/survey.service";
import ClientService from "../../services/client.service";  
import ReportService from "../../services/report.service";  
import MoneyballStickChart from "../../views/echarts/MoneyballStickChart.vue";
import SaveChart from "../chart/SaveChart.vue";
import DashboardCardDropdown from "./DashboardCardDropdown";
import DashboardCardSkeleton from "../../components/skeleton/DashboardCardSkeleton.vue";
import "echarts/lib/chart/heatmap";
import Multiselect from "vue-multiselect";

export default {
  name: "DashboardMoneyballStick",
  mixins: [DashboardMixins],
  components: { SaveChart,DashboardCardSkeleton,DashboardCardDropdown,Multiselect,MoneyballStickChart },
  data() {
    return {
      initialCompetitorsLoaded: false,
      title: "Moneyball Stick",
      modalName: "moneyball-stick-save-chart-confirmation",     
      stickBy: [],
      values: [],
      disableStickByWidget: false,
      stickType: "",
      noData: true,
      stick_type_options: [
        { value: "by-competitor", name: "By Competitor" },
        { value: "by-benchmark", name: "By Benchmark" },
        { value: "by-segment", name: "By Segment" },
        { value: "trends", name: "Trends" },
      ],
      by_competitor_options: [],
      by_benchmark_options: [],
      by_segment_options: [],
      trends_options: [],
      options: {},
    };
  },
  props: {
    entryClientChart: {
      type: Object,
      default: function () {
        return {};
      },
    },
    inputCompetitorOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    inputClientCharts: {
      type: Array,
      default: function() {
        return [];
      }
    },
    inputClientTimePeriodOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    inputSaveSettings: {
      type: Boolean,
      default: false
    },
    maximumStickByOptions: {
      type: Number,
      default: 3
    },    
  },
  computed: {
    byTypeName: function() {
        if (this.stickType == "by-competitor"){
            return "By Competitor";      
        } else if (this.stickType == "by-benchmark"){
            return "By Benchmark";      
        } else if (this.stickType == "by-segment"){
            return "By Segment";      
        } else if (this.stickType == "trends"){
            return "Trends";      
        }
        return "";
    },
    byTypeOptions: function() {
        if (this.stickType == "by-competitor"){
            return this.by_competitor_options;      
        } else if (this.stickType == "by-benchmark"){
            return this.by_benchmark_options;      
        } else if (this.stickType == "by-segment"){
            return this.by_segment_options;      
        } else if (this.stickType == "trends"){
            return this.trends_options;      
        }
        return [];
    },
    showCompetitorsDropdown: function(){
      return this.by_competitor_options.length > 0;
    },
    maximumStickByOptionMessage: function() {
      return "Maximum of " + this.maximumStickByOptions + " options. Clear your selections and chose again.";
    },        
  },
  mounted() {
    this.setChartDetails();
  },
  created() {},
  methods: {
    
    setAdditionalCardDisplay(){
      let id = '#dashboard-moneyball-stick';
      this.setAdditionalCardDisplayById(id);
    },
    getSavedChartsByClientIdCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let data = response.data.data;
        let saved_card_options = [];
        for (var i = 0; i < data.length; i++) {
          saved_card_options.push({ clientChartId: data[i].clientChartId, value: String(data[i].clientChartId), name: data[i].name, chartTypeId: data[i].chartTypeId });
        }
        saved_card_options.sort(ReportService.compareValues("name", "asc"));
        this.loadSegments(saved_card_options);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    initialLoadData: async function() {
      // eslint-disable-next-line no-console
     //console.log("DashboardMoneyballStick::initialLoadData this.autoGenerateChartRun: " + this.autoGenerateChartRun + "  client id: " + this.entryClientChart.clientId + "  time period id: " + this.timePeriodId + "    this.loadCompetitorData: " + this.loadCompetitorData);
      this.clearData();
      if (this.loadCompetitorData == true){
        let clientId = (typeof this.entryClientChart !== "undefined" && typeof this.entryClientChart.clientId !== "undefined") ? this.entryClientChart.clientId : this.$parent.$parent.clientId;
        await ClientCompetitorService.getCompetitors(clientId, this.timePeriodId, true, this.loadCompetitors, true);
        if (this.entryClientChart !== "undefined" && this.entryClientChart.surveyId != "") {       
          let surveyCode = SurveyService.getSurveyCodeBySurveyId(this.entryClientChart.surveyId);        
          await ClientTimePeriodService.getClientTimePeriodsBySurveyCode(surveyCode, this.getClientTimePeriodsBySurveyCodeCallback, this);
        }
        this.initialCompetitorsLoaded = true;
      }
      if (this.entryClientChart !== "undefined" && typeof this.entryClientChart.clientId !== "undefined") {
        let clientId = this.entryClientChart.clientId;
        await ClientService.getSavedChartsByClientId(clientId, this.getSavedChartsByClientIdCallback, this);
      } else {
        let saved_card_options = await ClientService.getAllSavedChartsByChartType(this.inputClientCharts, 1);
        saved_card_options.sort(ReportService.compareValues("name", "asc"));
        this.loadSegments(saved_card_options);
      }
      await ChartService.getTopCompanies(process.env.VUE_APP_BASE_URL, this.loadBenchmarkCompanies);
      if (this.autoGenerateChartRun){
        let vm = this;
        setTimeout(function() {
          vm.processAutoGenerateChart();
          vm.updateCard();
        }, 0);
      } else {
        this.setStickType();
        this.setStickBy();
        this.displayDashboard = true; 
      }
      this.setChartDetails();
    },
    loadData: function() {},
    addStickByOption(selectedOption) {
      selectedOption.checked = true;
    },  
    removeStickByOption(selectedOption) {
      selectedOption.checked = false;
    },
    setValues(value){
      this.values = [];
      this.stickBy = [];
      if (typeof value === 'string' && value.includes(',')) {
        this.stickBy = value.split(",");
      } else {
        if (this.stickBy.includes(value) == false){
          this.stickBy.push(value);
        }
      }
      if (typeof value === 'string' && value.includes('|')) {
        this.stickBy = value.split("|");
      } else {
        if (this.stickBy.includes(value) == false && isNaN(value) == false){
          this.stickBy.push(value);
        }
      }
      this.stickBy = this.stickBy.map(Number);
      for (var i = 0; i < this.byTypeOptions.length; i++) {
        for (var stickByIndex = 0; stickByIndex < this.stickBy.length; stickByIndex++) {
          if (this.byTypeOptions[i].value == this.stickBy[stickByIndex]) {
            this.byTypeOptions[i].checked = true;
            this.values.push(this.byTypeOptions[i]);
            break;
          } else {
            this.byTypeOptions[i].checked = false;
          }
        }  
      }
    },
    setStickBy() {
      let userSettingValue = "";
      let defaultDashboardUserSetting = this.$parent.defaultDashboardValues.find(x => x.userSettingTypeName == DashboardService.DASHBOARD_MONEYBALL_STICK_BY_TYPE_SETTING_TYPE);      
      if (typeof defaultDashboardUserSetting != "undefined") {
        userSettingValue = defaultDashboardUserSetting.userSettingValue;
        if (this.stickType != "trends"){
          this.setValues(userSettingValue);
        } else if (!isNaN(userSettingValue) == false) {
          this.setValues(userSettingValue);
        }
      }
    },
    setStickType() {
      //console.log("DashboardMoneyballStick::setStickType stickType " + this.stickType + " stick_type_options " + JSON.stringify(this.stick_type_options));
      this.stickType = DashboardService.getDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_MONEYBALL_STICK_STICK_TYPE_SETTING_TYPE, this.stickType, this.stick_type_options);
      let stickTypeFound = this.stick_type_options.find(x => x.value == this.stickType);
      if (typeof stickTypeFound == "undefined") {
        this.stickType = "by-competitor";
        this.clearSelections();
      } else {
        this.updateCard();
      }
    },
    saveStickType: function (value) {
      this.stickType = value;
      DashboardService.setDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_MONEYBALL_STICK_STICK_TYPE_SETTING_TYPE, this.stickType);
      this.clearSelections();
    },
    setDefaultTimePeriodForTrends() {
      if (this.stickType == "trends"){
        let found = this.trends_options.find(x => x.value == this.timePeriodId);
        if (typeof found != "undefined") {
          found.checked = true;
          this.values.push(found);
          this.addStickByOption(found);
        }
      }
    },
    clearSelections() {
      //console.log("DashboardMoneyballStick::clearSelections");
      for (var i = 0; i < this.values.length; i++) {
        this.values[i].checked = false;
      }
      for (var byTypeOptionsIndex = 0; byTypeOptionsIndex < this.byTypeOptions.length; byTypeOptionsIndex++) {
        this.byTypeOptions[byTypeOptionsIndex].checked = false;
      }
      this.stickBy = [];
      this.values = [];
      this.updateCard();
    },
    updateCard: function() {
      this.resetChart();
      if (this.initialCompetitorsLoaded == true){
        this.displayDashboard = false;
        this.$emit('loaded',false);
        let vm = this;
        setTimeout(function() {
          if (vm.timePeriodId != "" && vm.stickType != "") {
            vm.displayDashboard = false;
            vm.stickBy = vm.values.map(x => x.value); 
            if (!vm.autoGenerateChartRun){            
              let stickByValue = vm.stickBy.join(",");
              DashboardService.setDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_MONEYBALL_STICK_BY_TYPE_SETTING_TYPE, stickByValue);
            }
            if (vm.stickBy.length == 0 && vm.stickType == "trends") {
              vm.setDefaultTimePeriodForTrends();
            }
            this.disableStickByWidget = true;
            try {
              DashboardService.getMoneyballStick(vm.timePeriodId, vm.stickType, vm.stickBy, vm.inputSurveyGroupId, vm.inputUseEqualWeight, vm.inputSaveSettings, vm.getMoneyballStickCallback, vm);
            } catch (e) {
              AdminService.displayErrorMessage("DashboardService.getMoneyballStick", e, "admin", this);
              this.$emit('loaded',true);
            }
          } else {
            vm.displayDashboard = true;
          }
        }, 0);
      }
    },
    loadCompetitors(data) {
      this.by_competitor_options = [];
      for (var i = 0; i < data.length; i++) {
        this.by_competitor_options.push({ value: data[i].companyId, name: data[i].name });
      }
    },
    loadSegments(data) {
      //console.log("DashboardMoneyballStick::loadBenchmarkCompanies data " + JSON.stringify(data));
      this.by_segment_options = [];
      for (var i = 0; i < data.length; i++) {
        this.by_segment_options.push({ value: data[i].clientChartId, name: data[i].name });
      }
    },
    loadBenchmarkCompanies(data) {
      //console.log("DashboardMoneyballStick::loadBenchmarkCompanies data " + JSON.stringify(data));
      this.by_benchmark_options = [];
      for (var i = 0; i < data.length; i++) {
        this.by_benchmark_options.push({ value: data[i].companyId, name: data[i].name });
      }
    },
    loadClientTimePeriods(data) {
      //console.log("DashboardMoneyballStick::loadClientTimePeriods data " + JSON.stringify(data));
      this.trends_options = [];
      for (var i = 0; i < data.length; i++) {
        this.trends_options.push({ value: data[i].clientTimePeriodId, name: data[i].displayName });
      }
    },
    setChartDetails(){
      this.chartTitle = "Moneyball Stick";
      this.chartTypeName = "dashboard-moneyball-stick";
      this.containerId = "moneyball-stick-snap-id";
    	this.reportTypeName = "Dashboard - Moneyball Stick";
      this.modalName = "moneyball-stick-save-chart-confirmation";
      this.dashboardSurveyGroupId = this.inputSurveyGroupId;
      this.dashboardUseEqualWeight = this.inputUseEqualWeight;
    },
    clearData() {
      //console.log("DashboardMoneyballStick::clearData");
      this.noData = true;
      this.displayDashboard = false;
      this.stickBy= [];
      this.values = [];
      //this.clearSelections();
    },
    processSavedChartCriteria(criteria) {
      let criteriaParameters = criteria.split("=");
      let isStickType = criteriaParameters[0] == "stickType" ? true : false;
  		if (isStickType){
        this.stickType = criteriaParameters[1];
  		}
      let isStickBy = criteriaParameters[0] == "stickBy" ? true : false;
  		if (isStickBy){
        let savedStickBy = "";
        try {
          savedStickBy = JSON.parse(criteriaParameters[1]);
        } catch (e) {
          savedStickBy = decodeURIComponent(criteriaParameters[1]).replace(/\+/g, " ");
        }  
        this.setValues(savedStickBy);
  		}    
      let isDashboardSurveyGroupId = criteriaParameters[0] == "dashboardSurveyGroupId" ? true : false;
  		if (isDashboardSurveyGroupId){
        this.dashboardSurveyGroupId = criteriaParameters[1];
  		}   
      let isDashboardUseEqualWeight = criteriaParameters[0] == "dashboardUseEqualWeight" ? true : false;
  		if (isDashboardUseEqualWeight){
        this.dashboardUseEqualWeight = criteriaParameters[1];
  		} 
    },    
    buildUrlParams(client_id) {
      let params = this.buildBaseUrlParams();
      params.append("stickType",this.stickType);
      params.append("stickBy",this.stickBy);      
      return params;
    },  
    getClientTimePeriodsBySurveyCodeCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.loadClientTimePeriods(response.data.data.clientTimePeriods);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },  
    getMoneyballStickCallback(response) {
      this.disableStickByWidget = false;
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        if (!this.autoGenerateChartRun){
          this.setupClientChart();
        }      
        let seriesData = response.data.data;
        this.noData = seriesData.noData;
        if (this.noData == false && this.$refs.eChart){
          this.$refs.eChart.processChart(true,seriesData,true,this.autoGenerateChartRun);
          this.options = this.$refs.eChart.options;
        }
        this.displayDashboard = true;
        if (this.autoGenerateChartRun && !this.readOnly){
          this.minDashboardChartHeight = 0;
        }
        this.setAdditionalCardDisplay();
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.$emit('loaded',true);
    },
  },
  watch: {
    inputCompetitorOptions: function() {
      this.by_competitor_options = JSON.parse(JSON.stringify(this.inputCompetitorOptions)); 
      this.initialCompetitorsLoaded = true;
    },
    inputClientTimePeriodOptions: function() {
      let data = JSON.parse(JSON.stringify(this.inputClientTimePeriodOptions));      
      this.loadClientTimePeriods(data);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>